/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Lot_Debt_ColInputs */

const vi_order_lot_debt_col = /** @type {(inputs: Order_Lot_Debt_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nợ hàng`)
};

/**

* @param {Order_Lot_Debt_ColInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_lot_debt_col = /** @type {((inputs?: Order_Lot_Debt_ColInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Lot_Debt_ColInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_lot_debt_col(inputs)
});